import React, { useState } from "react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { RootState } from "src/redux/reducers";
import { setCreatorSearchLockedModalVisibility } from "src/redux";
import { SidebarItemType, SystemSidebarItem } from "src/types";
import { ReactComponent as CompassIcon } from "../../../images/compass.svg";
import { ReactComponent as ChevronIcon } from "../../../images/chevron-down.svg";
import getCreatorDiscoverySidebarItems from "./utils";

import "./CreatorDiscoveryLink.scss";

const SINGLE_MENU_ITEM_HEIGHT = 48;

export default function CreatorDiscoveryLink() {
  const [visible, setVisible] = useState(
    window.location.pathname.includes(`/creator-discovery-tool`),
  );

  const {
    mainReducer: { activeWorkspaceUuid, identity },
  } = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const location = window.location.pathname + window.location.search;

  const baseUrl = `/workspace/${activeWorkspaceUuid}`;

  const isCDT = location.includes(`/creator-discovery-tool`);

  const isList = isCDT && location.includes("/hashtag-live-search");

  const discoveryItem = identity?.sidebarItems?.find(
    (item) =>
      item.type === SidebarItemType.System &&
      item?.key === "front_sidebar_item_creator_discovery",
  ) as SystemSidebarItem | undefined;

  const discoveryItemsChildren = discoveryItem?.children;

  const handleOpenCreatorSearchLockedModalForDemoWorkspace = () => {
    if (identity?.isDemoWorkspace) {
      dispatch(setCreatorSearchLockedModalVisibility(true));
    }
  };

  const creatorDiscoverySidebarItems = getCreatorDiscoverySidebarItems(
    Boolean(identity?.isDemoWorkspace),
    handleOpenCreatorSearchLockedModalForDemoWorkspace,
    baseUrl,
    isList,
  );

  const filteredCreatorDiscoverySidebarItems =
    creatorDiscoverySidebarItems.filter((item) =>
      discoveryItemsChildren?.find((el) => el.key === item.key),
    );

  return (
    <li className="creator-discovery-link">
      <button
        className={classNames("sidebar__item button-style-reset", {
          "sidebar__item--active": isCDT,
          "sidebar__item--open": visible,
        })}
        onClick={() => setVisible((v) => !v)}
        type="button"
      >
        <CompassIcon />
        <span className="sidebar__item-text creator-discovery-link__button-text">
          <IDHFormattedMessage id="ws_discovery" defaultMessage="Discovery" />
          <ChevronIcon className="chevron-icon" />
        </span>
      </button>

      <ul
        className={classNames("creator-discovery-link__elements", {
          "creator-discovery-link__elements--visible": visible,
        })}
        style={{
          height: visible
            ? `${filteredCreatorDiscoverySidebarItems.length * SINGLE_MENU_ITEM_HEIGHT}px`
            : 0,
        }}
      >
        {filteredCreatorDiscoverySidebarItems.map((item) => (
          <li
            key={item.translateKey}
            className={classNames("sidebar__item", {
              "sidebar__item--active-light": item.activeLight,
            })}
          >
            <Link to={item.to} onClick={item.onClick}>
              &nbsp;
              <span className="sidebar__item-text">
                <IDHFormattedMessage
                  id={item.translateKey}
                  defaultMessage={item.defaultMessage}
                />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
}
